import { useEffect, useState } from "react";
import { iNft } from "../../../assets/models/iNft";
import NftController from "../../../assets/Controllers/NftController";
import Nav from "../../components/Nav/Nav";
import heroImg from "../../../assets/img/sfl/hero.png";
import logosfl from "../../../assets/img/sfl/sfl-logo.png";
import logo from "../../../assets/TakyonDesignSystem/images/TakyonLight.svg";
import Button from "../../../assets/TakyonDesignSystem/components/Button/Button";
import { iWallSlot, WALL_SLOT_TYPE } from "../../../config/wall";
import { COLLECTION_TYPE } from "../../../assets/models/iCollection";
import TakCard from "../../../assets/TakyonDesignSystem/components/TakCard/TakCard";
import Footer from "../../components/Footer/Footer";
import { SMALL_SCREEN } from "../../../assets/Utils/generic";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { SUORCE_BUYER_KEY } from "../../components/Checkout/WalletCheckout";

export default function SFL() {
  const [isLoading, setIsLoading] = useState(true);
  const [nfts, setNfts] = useState<iNft[]>([]);
  const isSmallScreen = useMediaQuery({ query: SMALL_SCREEN });

  const { t } = useTranslation();

  const mixedTakgetInspired = {
    $or: [
      {
        $and: [
          {
            $or: [
              { "payload.type": { $exists: false } },
              { "payload.type": "hotel" },
              { "payload.type": null },
            ],
          },
          {
            $or: [
              { isHotelFakeSupply: { $exists: false } },
              { isHotelFakeSupply: false },
            ],
          },
        ],
      },
      {
        $and: [
          {
            $or: [
              { "payload.type": { $exists: false } },
              { "payload.type": "hotel" },
              { "payload.type": null },
            ],
          },
          {
            isHotelFakeSupply: true,
          },
        ],
      },
      {
        "payload.type": COLLECTION_TYPE.experience,
      },
    ],
    sellStatus: "FOR_SALE",
  };

  const stays: iWallSlot = {
    title: "secondary.stays_title",
    config: {
      type: WALL_SLOT_TYPE.CLASSIC,
      payload: {
        scroll: false,
        query: mixedTakgetInspired,
        sort: { isHotelFakeSupply: 1 },
      },
    },
  };

  const loadNfts = async () => {
    setIsLoading(true);
    try {
      // Use type assertion to access the payload properties
      const payload = stays.config.payload as { sort: any; query: any };

      const data = await NftController.getPaginated({
        page: 1,
        sort: JSON.stringify(payload.sort),
        query: JSON.stringify(payload.query),
      });

      setNfts(data.data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadNfts();

    window.localStorage.setItem(SUORCE_BUYER_KEY, "suite-for-life");
  }, []);

  return (
    <div className="w-screen">
      <Nav />

      <div
        style={{
          background: `url(${heroImg})`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
          width: "100vw",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0, 35, 61, 0.8)",
            paddingTop: "100px",
          }}
          className="d-flex flex-column h100 w100 align-items-center justify-content-center"
        >
          <div className="d-flex align-items-center justify-content-center">
            <img style={{ height: "40px" }} src={logo} alt="" />
            <div
              style={{
                height: "100px",
                width: "3px",
                backgroundColor: "white",
                margin: "0 30px",
              }}
            ></div>
            <img style={{ height: "60px" }} src={logosfl} alt="" />
          </div>

          <br />

          <div
            style={
              isSmallScreen
                ? {
                    fontSize: "30px",
                    fontWeight: "900",
                    lineHeight: "35px",
                    padding: "0 10px",
                  }
                : { fontSize: "50px", fontWeight: "900", lineHeight: "55px" }
            }
            className="d-flex flex-column align-items-center justify-content-center"
          >
            <p className="text-white text-center">{t("sfl.headline-line1")}</p>
            <p className="sfl-color text-center">{t("sfl.headline-line2")}</p>
          </div>

          <br />

          <p
            className="text-white text-center"
            style={{ maxWidth: "700px", fontSize: "20px", padding: "0 10px" }}
          >
            {t("sfl.subheadline")}
          </p>

          <br />
          <br />
          <br />

          <Button
            onClick={() => {
              const section = document.getElementById("section-1");
              if (section) {
                const yOffset = -54;
                const y =
                  section.getBoundingClientRect().top +
                  window.pageYOffset +
                  yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }}
            className="sfl-button"
            text={t("sfl.cta-button")}
          />
          <br />
        </div>
      </div>

      <div id="section-1" className="bg-white h100">
        <div className="container d-flex flex-column">
          <div style={{ marginTop: "40px" }}></div>

          <div
            className={`d-flex gap-2  ${
              isSmallScreen ? "flex-column" : "align-items-end"
            }`}
          >
            <p style={{ fontSize: "30px" }}>{t("sfl.daily-offers")}</p>
            <p className="mb-1">- {t("sfl.new-daily")}</p>
          </div>

          <div className="container mb-5 text-black">
            <div className="d-flex flex-column align-items-center justify-content-center gap-2 text-center">
              {/* <p className="fs-h1-lg fw-bolder m-0">{t(stays.title ?? "")}</p> */}
            </div>
          </div>
          <div className="d-flex justify-content-center">
            {isLoading ? (
              <div className="text-center">
                <p>...</p>
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, 310px)",
                  gap: "24px",
                  justifyContent: "center",
                  maxWidth: "100%",
                }}
              >
                {nfts.map((item, key) => (
                  <div
                    key={`takcard_${key}`}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <TakCard nft={item} key={`slot_${key}`} />
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* <StayRequest slot={stayRequest} /> */}
          <div style={{ marginTop: "80px" }}></div>
        </div>
      </div>

      <div className="black-background">
        <Footer />
      </div>
    </div>
  );
}
